export const formatOrderDate = (dateString) => {
    if (!dateString) return "";

    const normalized = typeof dateString === "string"
        ? dateString.replace(" ", "T")
        : dateString;

    const date = new Date(normalized);

    if (Number.isNaN(date.getTime())) {
        return dateString;
    }

    return date.toLocaleDateString("el-GR");
};

export const normalizeOrders = (rawOrders = [], t) => {
    return rawOrders.map((order) => {
        const completedValue = String(order?.isCompleted ?? "");

        let status = t ? t("In progress") : "Σε εξέλιξη";
        let statusType = "processing";

        if (completedValue === "1") {
            status = t ? t("Completed") : "Ολοκληρώθηκε";
            statusType = "completed";
        } else if (completedValue === "2") {
            status = t ? t("Cancelled") : "Ακυρώθηκε";
            statusType = "cancelled";
        }

        return {
            id: order?.id ?? "",
            date: formatOrderDate(order?.createDt),
            total: `${Number(order?.total || 0).toFixed(2)} €`,
            status,
            statusType,
            raw: order,
        };
    });
};